import React, { useEffect, useState } from "react";
import Banner from "../Components/Home/Banner";
import Bannerfeature from "../Components/Home/Bannerfeature";
import Bestselling from "../Components/Home/Bestselling";
import FreeshippingBgimage from "../Components/Home/FreeshippingBgimage";
import Category from "../Components/Home/Category";
import Newarrival from "../Components/Home/Newarrival";
import Testimonial from "../Components/Home/Testimonial";
import { useLocation } from "react-router-dom";
import Header from "../Components/Header/Header";
import NewBanner from "../Components/Home/NewBanner";

function Home() {
  
  const [cartRefresh, setCartRefresh] = useState(false);
  const refreshCart = () => {
    setCartRefresh((prev) => !prev); // Toggle the state to trigger refresh
  };



  const routePath = useLocation();
  const onTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    onTop()
  }, [routePath]);
  return (
    <>
      <Header cartRefresh={cartRefresh} />
      {/* <Banner /> */}
      <NewBanner/>
      <Bannerfeature />
      <Category />
      <Bestselling onCartUpdate={refreshCart} />
      <FreeshippingBgimage />
      <Newarrival onCartUpdate={refreshCart} />
      <Testimonial />
    </>
  );
}

export default Home;